<div  *ngIf="!(isLoading$ | async)">
    <div class="container" *ngIf="{resource: resource$ | async} as data">
        <div class="title">{{data.resource?.title}}</div>
        <div class="info-page-content" [innerHtml]="data.resource?.content | safeHtml"></div>
    </div>
</div>
